const customRugPadTermsHeading = "Following are important facts regarding your custom rug pad order:";
const customRugTermsHeading = "Following are important facts regarding your custom rug order:";
const customProductType = "Rug Pad";
const customProduct = "-custom";
const customStandardProduct = "-cstd";
const customExpiditeProduct = "-cexp";
const termsAndCondition = "Agree To Terms And Conditions";

const Constant = {
    customRugPadTermsHeading,
    customRugTermsHeading,
    customProductType,
    customProduct,
    customStandardProduct,
    customExpiditeProduct,
    termsAndCondition,
};

export default Constant;
